<template>
  <div v-if="roles.length" class="separate-rows" :data-testid="`user-item-${idParam}`">
    <ConfirmModal
      v-if="user && showModal"
      :title="t('UserManagement.deleteUser.title', { email: user.email })"
      :cancel="t('UserManagement.deleteUser.cancel')"
      :approve="t('UserManagement.deleteUser.confirm')"
      :show-floating-close-button="false"
      data-testid="user-item-del-modal"
      @close-dialog="closeDialog"
    />
    <div
      class="flex flex-col items-start gap-4 p-6 text-left tablet:flex-row tablet:items-center tablet:justify-between tablet:text-center"
      align="center"
    >
      <!-- Details -->
      <div class="text-left">
        <h3 data-testid="user-item-name">{{ user.firstName }} {{ user.lastName }}</h3>
        <p class="mb-0" data-testid="user-item-email">{{ user.email }}</p>
      </div>
      <!-- Actions -->
      <div class="flex flex-col items-start gap-2 text-left tablet:flex-row tablet:items-center tablet:text-right">
        <RouterLink class="btn-outline-neutral-xs" data-testid="user-item-edit" :to="{ name: 'editUser', params: { id: idParam } }">
          {{ t('UserManagement.UserItem.editUser') }}
          <MdiSvg :path="mdiPencilOutline" :size="16" />
        </RouterLink>
        <button class="btn-outline-destructive-xs" data-testid="user-item-delete" :disabled="loading" @click="showModal = true">
          {{ t('UserManagement.UserItem.deleteUser') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { mdiPencilOutline } from '@mdi/js'
import { MdiSvg } from '@ramp106/omrjs-core-ui'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { type User } from '@/gql/myomr'
import { toTypeAndId } from '@/helpers/globalIdHelper'

import { useUserRoleEdit } from './useUserRoleEdit'

const { t } = useI18n()

const emit = defineEmits(['reloadUsers'])

const props = defineProps<{
  user: User
  forPartnerCompanyId: string
}>()

const showModal = ref(false)

const idParam = computed(() => toTypeAndId(props.user.id)['id'])
const roles = computed(() => {
  return props.user.roles.filter((role) => role.resourceId === props.forPartnerCompanyId && role.name.includes('manage__'))
})

const { editUser, loading } = useUserRoleEdit()
const deleteUser = () => editUser(props.user, [], () => emit('reloadUsers'))

function closeDialog(confirm: boolean) {
  if (confirm) deleteUser()
  showModal.value = false
}
</script>
